import { render, staticRenderFns } from "./CustomerDetailReport.vue?vue&type=template&id=18166ccc&scoped=true&"
import script from "./CustomerDetailReport.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailReport.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailReport.vue?vue&type=style&index=0&id=18166ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18166ccc",
  null
  
)

export default component.exports